import { render } from "./UsersExpiringList.vue?vue&type=template&id=4a387aa9&scoped=true"
import script from "./UsersExpiringList.vue?vue&type=script&lang=js"
export * from "./UsersExpiringList.vue?vue&type=script&lang=js"

import "./UsersExpiringList.vue?vue&type=style&index=0&id=4a387aa9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a387aa9"]])

export default __exports__